/**
 * @desc 分页查询退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.asRefundOrder.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/asRefundOrder/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
